// Utility type guards
function isPlainObject(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}
function arraysShallowEqual(a, b) {
    if (a === b)
        return true;
    if (a.length !== b.length)
        return false;
    for (let i = 0; i < a.length; i += 1) {
        if (JSON.stringify(a[i]) !== JSON.stringify(b[i])) {
            return false;
        }
    }
    return true;
}
function plainObjectsShallowEqual(a, b) {
    const keys = new Set([
        ...Object.keys(a),
        ...Object.keys(b),
    ]);
    for (const key of keys) {
        const aVal = a[key];
        const bVal = b[key];
        {
            if (JSON.stringify(aVal) !== JSON.stringify(bVal)) {
                return false;
            }
        }
    }
    return true;
}
// Remember that DTO's are created from zod Schemas, and deltas are created with
// schema.Partial, which is a shallow partial. Thus, we never truly recurse
// into nested objects.
export function createDeltaDTO(originalObject, newObject) {
    if (newObject === originalObject) {
        return {};
    }
    if (!isPlainObject(newObject) || !isPlainObject(originalObject)) {
        // If either is not a plain object, then the entire value is considered changed.
        return newObject;
    }
    const delta = {};
    const keys = new Set([
        ...Object.keys(newObject ?? {}),
        ...Object.keys(originalObject ?? {}),
    ]);
    for (const key of keys) {
        const nextVal = newObject?.[key];
        const prevVal = originalObject?.[key];
        // Both are plain objects: recurse but treat as atomic
        if (isPlainObject(nextVal) && isPlainObject(prevVal)) {
            if (!plainObjectsShallowEqual(nextVal, prevVal)) {
                delta[key] = nextVal;
            }
            // const childDelta = createDeltaDTO(nextVal, prevVal);
            // if (isPlainObject(childDelta) && Object.keys(childDelta).length === 0) {
            //   // No changes in this nested object
            //   continue;
            // }
            // delta[key] = childDelta;
            continue;
        }
        // Arrays: compare shallowly, treat as atomic
        if (Array.isArray(nextVal) && Array.isArray(prevVal)) {
            if (!arraysShallowEqual(nextVal, prevVal)) {
                delta[key] = nextVal;
            }
            continue;
        }
        // Primitive or mismatched types: simple inequality
        if (nextVal !== prevVal) {
            delta[key] = nextVal;
        }
    }
    return delta;
}
// Returns a new object with the changes applied from `delta`. Does not mutate `obj`.
export function applyDTODelta(obj, delta) {
    if (!isPlainObject(delta)) {
        // If delta is not an object, it represents a full replacement.
        return delta;
    }
    const base = isPlainObject(obj) ? { ...obj } : {};
    for (const [key, deltaVal] of Object.entries(delta)) {
        // const currentVal = base[key];
        base[key] = deltaVal;
        // Since we do shallow compares in creation, no reason to recurse during apply.
        // if (isPlainObject(deltaVal) && isPlainObject(currentVal)) {
        //   // Both are plain objects: apply
        //   base[key] = applyDTODelta(currentVal, deltaVal);
        // } else {
        //   // Primitive, array, or type mismatch: overwrite
        //   base[key] = isPlainObject(deltaVal)
        //     ? applyDTODelta(currentVal, deltaVal)
        //     : deltaVal;
        // }
    }
    return base;
}
